import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    path: '/transporte/traAluno',
    name: 'traaluno',
    description: 'Solicitação e Passe',
    component: () => import('@/views/transporte/traaluno/Index.vue'),
    meta: { permissions: [eTipoPermissao.SOLICITACAOEPASSENOVO_MENU_1100100199] },
    goesToMenu: true,
  },
];
